import { apiSlice } from "./apiSlice";
import { MEDIA_UPLOAD_URL, WS_MESSAGE_URL } from "../constants";

const wsMessageSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendWsMessage: builder.mutation({
      query: (data) => ({
        url: `${WS_MESSAGE_URL}${data?.params ? "/" + data.params : ""}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),

    getWsMessage: builder.query({
      query: (data) => ({
        url: `${WS_MESSAGE_URL}${data?.query ? data.query : ""}`,
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    createWhatsAppAds: builder.mutation({
      query: (data) => ({
        url: `${WS_MESSAGE_URL}/createWhatsAppAds`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    getWhatsAppAds: builder.query({
      query: (data) => ({
        url: `${WS_MESSAGE_URL}/getWhatsAppAds?${
          data?.query ? data.query : ""
        }`,
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    getMyWhatsAppAds: builder.query({
      query: (data) => ({
        url: `${WS_MESSAGE_URL}/getMyWhatsAppAds?${
          data?.query ? data.query : ""
        }`,
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    getWhatsAppBalance: builder.query({
      query: (data) => ({
        url: `${WS_MESSAGE_URL}/getWhatsAppBalance`,
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),

    updateWhatsAppMsgStatus: builder.mutation({
      query: ({ gymId, userId, token }) => ({
        url: `${WS_MESSAGE_URL}/updateWhatsAppMsgStatus`,
        method: "PUT",
        body: {
          gymId,
          userId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    sendWsMessageToCustomer: builder.mutation({
      query: (data) => ({
        url: `${WS_MESSAGE_URL}/sendWhatsAppMessageToCustomer`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    sendVideoMessage: builder.mutation({
      query: (data) => ({
        url: `${MEDIA_UPLOAD_URL}/sendVideoMessage`,
        method: "POST",
        body: data.payload, // FormData
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),

    sendImageMessage: builder.mutation({
      query: (data) => ({
        url: `${MEDIA_UPLOAD_URL}/sendImageMessage`,
        method: "POST",
        body: data.payload, // FormData
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    sendImageMessageFromS3: builder.mutation({
      query: (data) => ({
        url: `${WS_MESSAGE_URL}/sendWhatsAppAdImageFromS3`,
        method: "POST",
        body: data.payload, // FormData
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
  }),
});

export const {
  useSendWsMessageMutation,
  useGetWsMessageQuery,
  useLazyGetWsMessageQuery,
  useCreateWhatsAppAdsMutation,
  useGetWhatsAppAdsQuery,
  useGetWhatsAppBalanceQuery,
  useGetMyWhatsAppAdsQuery,
  useUpdateWhatsAppMsgStatusMutation,
  useSendWsMessageToCustomerMutation,
  useSendVideoMessageMutation,
  useSendImageMessageMutation,
  useSendImageMessageFromS3Mutation,
} = wsMessageSlice;
